var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"id":_vm.setFieldId,"label":_vm.label,"value":_vm.checked,"hint":_vm.hint},on:{"change":_vm.runUIValidation},model:{value:(_vm.boolean),callback:function ($$v) {_vm.boolean=$$v},expression:"boolean"}})}
var staticRenderFns = []

export { render, staticRenderFns }